module.exports = __webpack_public_path__ + "static/Quicksand-Medium-db0ad2fc713ab72ea682687be4bd1021.ttf";